/* 🤖 this file was generated by svg-to-ts */
export const emperorIconSwitchLeft1: {
  name: 'switch_left_1';
  data: string;
} = {
  name: 'switch_left_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M7 18.999h10c3.85 0 7-3.14 7-7s-3.15-7-7-7H7c-3.86 0-7 3.14-7 7s3.141 7 7 7Zm0-10c1.65 0 3 1.343 3 3s-1.35 3-3 3c-1.66 0-3-1.343-3-3s1.34-3 3-3Z"/></svg>`
};
